module.exports = __webpack_public_path__ + "static/img/groupInfo.e0866332.svg";